import { IAttachment } from "../../caseLawDocuments/model/Attachment";
import AttachmentMapper from "../../caseLawDocuments/service/AttachmentMapper";
import AttachmentParamMapper from "../../caseLawDocuments/service/AttachmentParamMapper";
import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";

export default class GetAttachmentsForCaseDecisionInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachment>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseDecisionId: string) {
    return this.resource.execute(
      `case-decisions/${caseDecisionId}/attachments`,
      AttachmentMapper,
      AttachmentParamMapper
    );
  }
}
